<template>
  <section v-if="key && available !== false" class="container instagram-block" v-observe-visibility="visibilityChanged">
    <div class="insta-block mt30" :class="{ 'insta-hidden': available !== true }">
      <div :class="key" v-if="loadInsta" data-elfsight-app-lazy />
    </div>
  </section>
</template>
<script>
import config from 'config'

let availabilityRequest = null

export default {
  name: 'InstagramFeed',
  data () {
    return {
      loadInsta: false,
      available: null
    }
  },
  computed: {
    key () {
      return config.instagram.elfsight_key
    }
  },
  mounted () {
    if (!this.key) return
    this.checkAvailability()
      .then(available => {
        this.available = available
      })
      .catch(error => {
        console.error('Instagram availability check failed: ', error)
        this.available = false
      })
  },
  methods: {
    checkAvailability () {
      if (!availabilityRequest) {
        const widgetId = this.key.replace('elfsight-app-', '')
        availabilityRequest = fetch(`${config.instagram.url}/?&w=${widgetId}`)
          .then(response => response.json())
          .then(res => !!(res.data.widgets[widgetId] && res.data.widgets[widgetId].data))
        availabilityRequest.catch(() => {
          availabilityRequest = null
        })
      }
      return availabilityRequest
    },
    visibilityChanged (isVisible) {
      if (this.loadInsta || !isVisible) return
      const platform = document.createElement('script')
      platform.defer = true
      platform.async = true
      platform.setAttribute('type', 'application/javascript')
      platform.setAttribute('src', '//apps.elfsight.com/p/platform.js')
      document.head.appendChild(platform)
      this.loadInsta = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~theme/css/animations/transitions";

  .tile {
    display: flex;
    overflow: hidden;
      border-radius: 10px;
      height: 95%;
  }
  .tile-image {
    width: 100%;
    height: 100%;
    transition: transform 0.3s $motion-main;
    &:hover,
    &:focus {
      transform: scale(1.2);
    }
  }
  .cl-accent{
    font-size: 30px;
  }
  .cl-accent {
    @media (max-width: 555px) {
      font-size: 28px;
    }
  }
    .insta-wrap{
        overflow: auto;
        overflow-x: scroll;
        white-space: nowrap;

        .insta-item{
            display: inline-block;
            width: 35vw;
            text-align: center;
            white-space: normal;
            margin: 5px;
            @media (min-width: 769px) {
                width: 29%;
            }
        }

    }
  .insta-block{
    height: 500px;
    @media (max-width: 768px) {
      height: 560px;
    }
    @media (max-width: 500px) {
      height: 506px;
    }
    @media (max-width: 400px) {
      height: 470px;
    }
    @media (max-width: 375px) {
      height: 670px;
    }
    &.insta-hidden {
      visibility: hidden;
    }
  }
</style>
